import { render, staticRenderFns } from "./WLA.vue?vue&type=template&id=6211b1de&"
import script from "./WLA.vue?vue&type=script&lang=js&"
export * from "./WLA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6211b1de')) {
      api.createRecord('6211b1de', component.options)
    } else {
      api.reload('6211b1de', component.options)
    }
    module.hot.accept("./WLA.vue?vue&type=template&id=6211b1de&", function () {
      api.rerender('6211b1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/WLA.vue"
export default component.exports